import React from 'react';
import times from 'lodash/times';

import { List } from '../components/List';
import FakeProjectItem from './components/FakeProjectItem';

interface IProps {
  isGrid: boolean;
}

const FakeProjectsList = ({ isGrid }: IProps) => (
  <List isGrid={isGrid}>
    {times(9).map(index => (
      <FakeProjectItem key={index} isGrid={isGrid} />
    ))}
  </List>
);

export default FakeProjectsList;
